import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What's an intermediate dev anyway?",
  "description": "",
  "published": "2018-06-21T00:00:00.000Z",
  "redirect_from": ["/blog/intermediate-dev/swizec/8468"],
  "categories": "Learning, Personal, Thoughts",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Mason writes on WIPchat 👇`}</p>
    <blockquote>
      <p parentName="blockquote">{`@swizec I'll be partnered on a project with a less experienced dev soon. We're going to use Gatsby, and he's never worked with React (but knows JS). First thing I did when the boss told me was to send the other a dev a link to your `}<a parentName="p" {...{
          "href": "https://twitter.com/Swizec/status/981932124231024640"
        }}>{`Learn While You Poop`}</a>{` thread 😊`}</p>
    </blockquote>
    <p>{`Thanks mate!`}</p>
    <blockquote>
      <p parentName="blockquote">{`This is also funny because `}<strong parentName="p">{`the PM approached me like I'm senior, but I still feel more on the 🍼👶 end of the skill spectrum`}</strong>{`. It seems like clients just assume I've been at it way longer than I have. I just roll with it 😬`}</p>
    </blockquote>
    <p>{`Congratz! 👏`}</p>
    <p>{`So I asked Mason how long he's been doing this: Coding for 6 years, professional web dev for 2-3 years.`}</p>
    <p>{`That's not too bad!`}</p>
    <p>{`I think that puts Mason solidly in the vast quagmire of `}<em parentName="p">{`Intermediate Developer`}</em>{`. A designation that is most hardest to wrestle into an exact definition.`}</p>
    <p>{`Large companies, of course, have well-defined ladders you can climb, but that's weird.`}</p>
    <p>{`To me, an intermediate developer is someone who…`}</p>
    <ul>
      <li parentName="ul">{`feels comfortable writing code,`}</li>
      <li parentName="ul">{`can come up with solutions on their own,`}</li>
      <li parentName="ul">{`often overthinks things,`}</li>
      <li parentName="ul">{`shoots themselves in the foot sometimes, and`}</li>
      <li parentName="ul">{`just needs exposure to real world problems and time to practice`}</li>
    </ul>
    <p>{`That last one is important.`}</p>
    <p>{`An intermediate developer is someone who can work independently but needs more experience. Experience is key. The more time you spend solving real-world problems for real-world businesses where the real money is on the line, the better you get.`}</p>
    <p>{`No, solving example problems and pre-defined puzzles do not grow you from intermediate to senior. I'm not even sure it gets you from beginner to intermediate.`}</p>
    <p>{`It's fun though! Do puzzles if you like them. Just know that, in the real world, nobody cares about the elegance of your solution unless there is a specific business requirement that says `}<em parentName="p">{`Must be elegant`}</em>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/06/realworldengineering.jpg",
        "alt": "True real world engineering, by Luka Kladaric"
      }}></img></p>
    <p>{`Deployed beats perfect every time. That was the hardest lesson for me to learn.`}</p>
    <p>{`Sure, go and be elegant if you're building a framework that tens of thousands of engineers are gonna use to solve real-world problems. But that's a very special place with very special rules.`}</p>
    <hr></hr>
    <p>{`So here's Mason. He's a good guy who isn't afraid of anything. But he thinks he's not senior enough to guide and mentor someone just starting out.`}</p>
    <p>{`Here's what Mason forgets 👉 According to the Stack Overflow survey, 67% of software engineers have less than 5 years of professional experience. Five years!`}</p>
    <p>{`But think about it. The web reached consumers in 1993 or so. Tim Bernes Lee put `}<a parentName="p" {...{
        "href": "http://info.cern.ch/hypertext/WWW/TheProject.html"
      }}>{`the very first web page`}</a>{` online in August 1991.`}</p>
    <p>{`That's just 27 years ago. The whole industry has existed for only 27 years.`}</p>
    <p>{`Did you know that 50% of the world still doesn't have internet access? 3.5 billion people left to reach over the next few decades.`}</p>
    <p>{`Can you even call putting the first website online the birth of an industry? 🤔 Was the automobile industry born in 1885 when Benz created his Motorwagen, the first internal combustion vehicle?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/06/Benz-1.jpg",
        "alt": "True real world engineering, by Luka Kladaric"
      }}></img></p>
    <p>{`Let's see, 1885 plus 27 years ... 1912. Just 4 years after the first mass-produced car, the Model T.`}</p>
    <p>{`That sounds about right, doesn't it? The web is just entering the era of mass production of web pages and websites and all sorts of web things.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/06/2560px-1925_Ford_Model_T_touring-1024x768.jpg",
        "alt": "True real world engineering, by Luka Kladaric"
      }}></img></p>
    <p>{`This mass production is what's driving the democratization of web development as a profession that we're seeing right now. More and more people are getting into web dev using better and better tools.`}</p>
    <p>{`Just like factory workers in the early 20th century. The industry was booming, and everyone wanted to build cars. That's where the jobs were.`}</p>
    <p>{`Programs were started to teach people just enough skills to be productive in a factory. People were trained up fast and worked hard.`}</p>
    <p>{`Give them the right tools and processes and anyone can build a car! Everyone should go build cars! We have more orders to fill than people to fulfill them!`}</p>
    <p>{`You know, just like everyone should go to a boot camp or a school and become a Web Developer. Learn a specific tool, a specific process, crank things out as fast as you can.`}</p>
    <p>{`But not everyone can design a car. You need an engineer for that.`}</p>
    <p>{`Be the person who builds the tools and designs the solutions. ❤️`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      